import { DataframeData } from "../../PortfolioManagement/types"

export enum Source {
  OBSERVED = "observed",
  PREDICTED = "predicted",
}

export enum Frequency {
  MONTHLY = "M",
  HALF_YEAR = "6M",
  QUARTERLY = "Q",
  YEARLY = "Y",
}

export type DashboardItem = {
  dataset_id: number | undefined | null
  dataset_name: string | undefined | null
  dataset_long_name: string | undefined | null
  company_id: number | undefined | null
  company_main_instrument_ticker: string | undefined | null
  fundamentals_source: FundamentalsSource | undefined | null
  fundamentals_periodicity: FundamentalsPeriodicity | undefined | null
  fundamentals_metric: string | undefined | null
  fundamentals_transformation: FundamentalsTransformationType | undefined | null
  output_transformation?: OutputTransformation | null
}

export enum FundamentalsSource {
  S14 = "S14",
}

export enum FundamentalsPeriodicity {
  QUARTERLY = "Q",
  FISCAL_YEAR = "FY",
  CALENDAR_YEAR = "CY",
  MONTHLY = "M",
  HALF_YEAR = "H",
}

export enum FundamentalsTransformationType {
  VALUE = "Value",
  PCT_YOY = "%YoY",
  NET_YEARLY_CHANGE = "Net Yearly Change",
  PCT_SOS = "%SoS",
  NET_SEQUENTIAL_CHANGE = "Net Sequential Change",
}

export enum OutputTransformation {
  NONE = "none",
  YOY = "yoy",
  SEQ = "seq",
  INDEX = "index", // Convert PoP data to index timeseries
}

/**
 * PoP data types that can be converted to an index timeseries.
 * These are percentage-based period-over-period types.
 */
export const POP_TYPES_CONVERTIBLE_TO_INDEX = ["MoM%", "QoQ%", "YoY%", "HoH%"]

/**
 * PoP data types that can be coherently converted to YoY via index compounding.
 * YoY% is excluded because you can't compute YoY of YoY.
 */
export const POP_TYPES_CONVERTIBLE_TO_YOY = ["MoM%", "QoQ%", "HoH%"]

export type DashboardLight = {
  id: number
  name: string
  owner: DashboardOwner
  updated_at: string
}

/**
 * Dashboard with items as returned by the API
 */
export type Dashboard = {
  id: number
  name: string
  owner: DashboardOwner
  items: DashboardItem[]
  updated_at: string
  z_score: boolean
  backtest: boolean
  source: Source
  freq: Frequency
}

export type DashboardOwner = {
  id: number
  username: string
}

/**
 * Dashboard with data as returned by the API
 */
export interface DashboardData extends Dashboard {
  data: DataframeData
}
